import {
  cloudyIndigoColor,
  darkRed,
  emeraldGreen,
  lightRedPaleBgV2,
  lightRedShade,
  outletInvoicingPrimaryShadow,
  outletInvoicingPrimaryShadowHover,
  redColor,
  redShadeStrong,
  strongBlue,
  strongBlueDark,
  white,
  whiteBlueShade
} from "../../../config/ColorObj";

/** Primary action button sx — used on billing preview & offer dialog */
export const primaryActionButtonSx = {
  bgcolor: strongBlue,
  color: white,
  fontWeight: 600,
  letterSpacing: "0.04em",
  px: 3,
  borderRadius: "8px",
  boxShadow: `0 2px 6px ${outletInvoicingPrimaryShadow}`,
  ":hover": {
    bgcolor: strongBlueDark,
    boxShadow: `0 4px 10px ${outletInvoicingPrimaryShadowHover}`,
  },
};

/** Compact primary button (Offer toolbar) */
export const primaryActionButtonCompactSx = {
  ...primaryActionButtonSx,
  px: 2.5,
};

/** Out-of-stock chip on order list action bar */
export const outOfStockChipSx = {
  bgcolor: lightRedShade,
  color: darkRed,
  fontWeight: 500,
  fontSize: 12,
};

/** Info chip on order list dialog header */
export const orderListInfoChipSx = {
  ml: "auto",
  bgcolor: whiteBlueShade,
  color: strongBlue,
  fontWeight: 600,
  fontSize: 12,
};

/** Muted helper text */
export const mutedBodyTextSx = {
  color: cloudyIndigoColor,
};

/** Warning panel title in order list dialog */
export const orderListWarningTitleSx = {
  fontSize: 13,
  fontWeight: 600,
  color: redShadeStrong,
  mb: 1.5,
};

/** Row background when product is out of stock */
export const outOfStockRowBg = {
	backgroundColor: lightRedPaleBgV2,
};

/** Invalid rate error text */
export const invalidRateTextSx = {
  color: redColor,
  fontSize: "11px",
  display: "block",
};

/** Stock value — zero */
export const stockZeroSx = {
  color: darkRed,
};

/** Stock value — low */
export const stockLowSx = {
  color: emeraldGreen,
};
